import { render, staticRenderFns } from "./FreeProductHero.vue?vue&type=template&id=040fa546&"
import script from "./FreeProductHero.vue?vue&type=script&lang=js&"
export * from "./FreeProductHero.vue?vue&type=script&lang=js&"
import style0 from "./FreeProductHero.vue?vue&type=style&index=0&id=040fa546&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports